import { Head, Link } from '@inertiajs/react';
import { useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';


interface FilterValue {
  id: number;
  value: string;
  active: boolean;
  position: number;
}

interface FilterCategory {
  id: number;
  name: string;
  key: string;
  description: string | null;
  active: boolean;
  position: number;
  filter_values: FilterValue[];
}

interface Props {
  filter_categories: FilterCategory[];
}

export default function FilterCategoriesIndex({ filter_categories }: Props) {
  const [categories] = useState(filter_categories);

  const handleSync = () => {
    window.location.href = '/admin/filter_categories/sync';
  };

  const handleExport = () => {
    window.location.href = '/admin/filter_categories/export';
  };

  return (
    <AdminLayout>
      <Head title="Gestion des filtres" />
      
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold">Gestion des filtres</h1>
            <p className="text-gray-600 mt-2">
              Gérez les catégories et valeurs de filtres pour la recherche de kinésithérapeutes
            </p>
          </div>
          <div className="flex space-x-3">
            <Button onClick={handleSync} variant="outline">
              Synchroniser
            </Button>
            <Button onClick={handleExport} variant="outline">
              Exporter
            </Button>
            <Link href="/admin/filter_categories/new">
              <Button>Nouvelle catégorie</Button>
            </Link>
          </div>
        </div>

        <div className="grid gap-6">
          {categories.map((category) => (
            <Card key={category.id}>
              <CardHeader>
                <div className="flex justify-between items-start">
                  <div>
                    <CardTitle className="flex items-center space-x-3">
                      <span>{category.name}</span>
                      <Badge variant={category.active ? "default" : "secondary"}>
                        {category.active ? "Actif" : "Inactif"}
                      </Badge>
                      <Badge variant="outline">
                        {category.filter_values.length} valeurs
                      </Badge>
                    </CardTitle>
                    <p className="text-sm text-gray-600 mt-1">
                      Clé: <code className="bg-gray-100 px-1 rounded">{category.key}</code>
                    </p>
                    {category.description && (
                      <p className="text-sm text-gray-600 mt-1">{category.description}</p>
                    )}
                  </div>
                  <div className="flex space-x-2">
                    <Link href={`/admin/filter_categories/${category.id}/filter_values`}>
                      <Button variant="outline" size="sm">
                        Gérer les valeurs
                      </Button>
                    </Link>
                    <Link href={`/admin/filter_categories/${category.id}/edit`}>
                      <Button variant="outline" size="sm">
                        Modifier
                      </Button>
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2">
                  {category.filter_values.slice(0, 5).map((value) => (
                    <Badge key={value.id} variant="outline" className="text-xs">
                      {value.value}
                    </Badge>
                  ))}
                  {category.filter_values.length > 5 && (
                    <Badge variant="outline" className="text-xs">
                      +{category.filter_values.length - 5} autres
                    </Badge>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
} 
